module.exports = __webpack_public_path__ + "static/media/ic_small_arrow_down.95c36487.svg";